var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed top-5 left-5 w-10 h-10 z-30 flex flex-col",on:{"click":_vm.openMobileMenu}},[_c('span',{staticClass:"ham-row"}),_c('span',{staticClass:"ham-row"}),_c('span',{staticClass:"ham-row"})])}
var staticRenderFns = []

export { render, staticRenderFns }